define(
  'app/views/campaign_popup_view',['app/setup'],
  function (takhfifan) {

    takhfifan.campaignPopupView = Backbone.View.extend({

      events: {
        'submit': 'submit'
      },

      initialize: function (options) {
        this.content = this.$el.find('.campaign-popup');
        this.actionLink = this.$el.data('registerAction');
        this.campaignName = this.$el.data('campaignName');
        this.$submitBtn = this.$el.find(':submit');
        this.render();
      },

      render: function () {
        $('.modal-overlay').show();
        this.content.show();
        takhfifan.eventHub.trigger('modal:showModalWithContent',
          {
            elementToOperate: this.$el,
            fadeTimeIn: 400
          });
      },

      validateEmail: function (email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
      },

      validatephone: function (phone) {
        var re = /[0-9]+$/;
        return re.test(phone);
      },

      checkFormValues: function (formData) {
        var result = {status: true, messages: []};
        var email = formData.email;
        var phone = formData.phone;

        if (email || phone) {
          if (email) {
            if (!this.validateEmail(email)) {
              result.status = false;
              result.messages.push('ایمیل وارد شده صحیح نمی باشد.');
            }
          }
          if (phone) {
            if (phone.length === 11) {
              if (!this.validatephone(phone)) {
                result.status = false;
                result.messages.push('شماره تلفن وارد شده صحیح نمی باشد.');
              }
            } else {
              result.status = false;
              result.messages.push('لطفا شماره تلفن را به صورت ۱۱ رقمی وارد نمایید.');
            }
          }
        } else {
          result.status = false;
          result.messages.push('وارد کردن شماره تلفن یا ایمیل برای ثبت نام ضروری است.');
        }
        return result;
      },

      gatherFormData: function () {
        var formData = {email: false, formData: false};
        formData.email = this.$el.find('input[name="email"]').val();
        formData.phone = this.$el.find('input[name="phone"]').val();

        return formData;
      },

      submit: function () {
        var _this = this;
        this.$submitBtn.prop("disabled",true);
        var formData = this.gatherFormData();
        var validateResult = this.checkFormValues(formData);
        if (validateResult.status) {
          $.ajax({
            type: 'POST',
            url: _this.actionLink,
            data: {
              form_key: takhfifan.formKey,
              phone: formData.phone,
              email: formData.email,
              campaign: _this.campaignName
            }
          }).done(function (data) {
            if (data && data.status === 200) {
              takhfifan.eventHub.trigger('modal:closeModalWithContent');
              var messsage = "ثبت نام شما با موفقیت انجام شد";
              if (data.msg && data.msg === "duplicate") {
                messsage = "ثبت نام شما در مسابقه قبلا انجام شده است";
              }
              takhfifan.eventHub.trigger('message:show', {
                type: 'success',
                msg: messsage
              });
            } else {
              _this.showErrorMessage('متاسفانه خطایی در ثبت نام شما رخ داد. لطفا مجدد تلاش نمایید.', true);
            }
          }).fail(function (e) {
            _this.showErrorMessage('متاسفانه ارتباط بر قرار نشد.لطفا مجدد تلاش نمایید', true);
          }).always(function (e) {
            _this.$submitBtn.prop("disabled",false);
          });
        } else {
          this.clearErrorMessage();
          validateResult.messages.forEach(function (msg) {
            _this.showErrorMessage(msg, false)
          });
          this.$submitBtn.prop("disabled",false);
        }
      },

      showErrorMessage: function (message, clearMessages) {
        if (!this.$errorMessage) {
          this.$errorMessage = this.$el.find('.tkh-error-message');
        }
        if (clearMessages) {
          this.$errorMessage.empty()
        }
        this.$errorMessage.text(this.$errorMessage.text() + "\n" + message);
        this.$errorMessage.css('visibility', 'visible');
      },

      clearErrorMessage: function () {
        if (!this.$errorMessage) {
          this.$errorMessage = this.$el.find('.tkh-error-message');
        }
        this.$errorMessage.empty();
      },
    });
  });

